import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import type { NativeStackScreenProps } from '@react-navigation/native-stack';
import { AppButton } from '../../components/AppButton';
import { AppCard } from '../../components/AppCard';
import { AppScreen } from '../../components/AppScreen';
import { ScreenHeader } from '../../components/ScreenHeader';
import { routes, type RootStackParamList } from '../../constants/routes';
import { spacing } from '../../constants/spacing';
import { typography } from '../../constants/typography';
import { useAuth } from '../../context/AuthContext';
import { useAppColors } from '../../context/PreferencesContext';
import { UnauthorizedScreen } from '../system/UnauthorizedScreen';

type Props = NativeStackScreenProps<RootStackParamList, 'OrganizationCreated'>;

export function OrganizationCreatedScreen({ navigation, route }: Props) {
  const auth = useAuth();
  const palette = useAppColors();
  if (!auth.roles?.includes('SUPER_ADMIN')) return <UnauthorizedScreen />;
  const params = route.params;
  return (
    <AppScreen>
      <ScreenHeader title="Organization Created" />
      <View style={styles.body}>
        <Text style={[styles.title, { color: palette.success }]}>Organization Created Successfully</Text>
        <AppCard style={styles.card}>
          <Text style={[styles.label, { color: palette.textSecondary }]}>Organization</Text>
          <Text style={[styles.value, { color: palette.textPrimary }]}>{params.organizationName}</Text>
          <Text style={[styles.label, { color: palette.textSecondary }]}>Organization Code</Text>
          <Text style={[styles.value, { color: palette.textPrimary }]}>{params.organizationCode}</Text>
        </AppCard>
        <AppButton title="Open Organization" onPress={() => navigation.replace(
          routes.managedOrganizationDetails, { organizationId: params.organizationId })} />
        <AppButton title="Create Another Organization" variant="secondary"
          onPress={() => navigation.replace(routes.organizationCreate)} />
      </View>
    </AppScreen>
  );
}
const styles = StyleSheet.create({
  body: { flex: 1, justifyContent: 'center', padding: spacing.lg, gap: spacing.lg },
  title: { ...typography.sectionTitle, textAlign: 'center' },
  card: { gap: spacing.sm },
  label: { ...typography.caption },
  value: { ...typography.body, fontWeight: '700' },
});
